import React from 'react';

// Shared layouts
import { Dashboard as DashboardLayout } from 'layouts';

// Component styles
import { makeStyles } from '@mui/styles';
import styles from './style';
import PowerFactorTable from './components/PowerFactorTable';
import { useNavigate, useParams } from 'react-router-dom';
import { SpeedDial } from '@mui/material';
import { Add } from '@mui/icons-material';
const useStyle = makeStyles(styles);

export function PowerFactor() {
  const classes = useStyle();
  const { meterId } = useParams();
  const navigate = useNavigate();

  return (
    <DashboardLayout>
      <div className={classes.root}>
        <div className={classes.content}>
          <PowerFactorTable meterId={meterId} />
        </div>
      </div>
      <SpeedDial
        sx={{
          position: 'fixed',
          bottom: 32,
          right: 32,
          '& .MuiFab-primary': {
            backgroundColor: '#00AFEF',
            color: '#fff',
            width: '60px',
            height: '60px',
            fontSize: '1.5em',
            '&:hover': {
              backgroundColor: 'rgb(0, 146, 199)',
            },
          },
        }}
        ariaLabel="SpeedDial basic example"
        icon={<Add />}
        onClick={() => navigate(`/newPowerFactor/${meterId}`)}
      />
    </DashboardLayout>
  );
}
